import React, { memo, useEffect, useRef } from 'react';
import { Flex } from 'antd';
import styles from './video.module.css';

interface VideoProps {
  src: string;
  title?: React.JSX.Element | string;
  subtitle?: React.JSX.Element | string;
  features?: React.JSX.Element;
}

function Video({ src, title, subtitle, features }: VideoProps) {
  const video = useRef<HTMLVideoElement | null>(null);

  useEffect(() => {
    if (video.current) {
      video.current.load();
    }
  }, []);

  return (
    <div className={styles.root}>
      <Flex
        vertical
        align='center'
        justify='center'
        className={styles.flexWrapper}
      >
        <div className={styles.filter} />
        <video
          ref={video}
          preload='metadata'
          src={src}
          muted
          loop
          playsInline
          autoPlay={false}
          className={styles.videoMain}
          onLoadedMetadata={() => video.current && video.current.play()}
        ></video>
        {title && <div className={styles.title}>{title}</div>}
        {subtitle && <span className={styles.subtitle}>{subtitle}</span>}
        {features}
      </Flex>
    </div>
  );
}

export default memo(Video);
